import React, { useEffect, useState } from "react";
import { GetBenchsaalesStats } from "../apiconstants/constants";
import axios from "axios";
import ReactPaginate from "react-paginate";
import LoadingSpinner from '../helpers/loadingspinner';
import nodataimg from "../assets/images/Nodata.jpg";
import ConsultantLayout from '../commonlayouts/consultantlayout';
import { Link } from "react-router-dom";
 import Tooltip from "react-bootstrap/Tooltip";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Select from "react-select";
import BenchSalesBarGraph from "./benchsalesbargraph";
export default function BenchsalesStats() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(0);
  const perPage = 10; // 👈 page size
  let Guid = "";
 const [filters, setFilters] = useState({ SubmittedDate: "" });
   const [selectedDateFilter, setSelectedDateFilter] = useState(null);
 const token = localStorage.getItem("jwtToken");

  const guid = localStorage.getItem("guid");
  const employerGuid = localStorage.getItem("employerGuid");
  const roleID = localStorage.getItem("roleID");
 
  if (roleID == 3) {
    Guid = employerGuid;
  } else {
    Guid = guid;
  }
   const dateFilterOptions = [
    { value: "", label: "Select Date Filter" },
    { value: "Past 7 days", label: "Past 7 days" },
    { value: "Past 30 days", label: "Past 30 days" },
    { value: "This month", label: "This month" },
    { value: "Past 6 months", label: "Past 6 months" },
    { value: "Past 1 year", label: "Past 1 year" },
    { value: "Past 2 years", label: "Past 2 years" },
    { value: "Past 3 years", label: "Past 3 years" },
  ];
  const handleFilterChange = (selectedOption) => {
    setSelectedDateFilter(selectedOption);
    setFilters((prevFilters) => ({
      ...prevFilters,
      SubmittedDate: selectedOption.label, // ✅ Store label for API
    }));
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await axios.get(GetBenchsaalesStats.APIURL, {
          params: {
            guid: Guid,
            DateFilter: filters.SubmittedDate || "This month", // 👈 correct variable
          },
          headers: {
            accept: "*/*",
            Authorization: `Bearer ${token}`,
          },
        });
        console.log("API Response:", response.data);
        setData(response.data || []);
      } catch (error) {
        console.error("Error fetching Bench stats", error);
      } finally {
        setLoading(false);
      }
    };
  
    fetchData();
  }, [Guid, filters.SubmittedDate]); 
  
  // Pagination logic
  const pageCount = Math.ceil(data.length / perPage);
  const offset = currentPage * perPage;
  const currentData = data.slice(offset, offset + perPage);
 
  const handlePageClick = ({ selected }) => {
    setCurrentPage(selected);
  };
 
  if (loading) {
    return (
      <center className="p-4">
        <LoadingSpinner />
      </center>
    );
  }
   const totals = data.reduce(
    (acc, curr) => {
      acc.overallCount += curr.submittedCount || 0;
      acc.new += curr.newCount || 0;
      acc.jobSubmission += curr.submittedStatusCount || 0;
      acc.shortlisted += curr.inProgressCount || 0;
      acc.interviewsScheduled += curr.interviewScheduledCount || 0;
      acc.rejected += curr.rejectedCount || 0;
      acc.onHold += curr.onHoldCount || 0;
      return acc;
    },
    {
      overallCount: 0,
      new: 0,
      jobSubmission: 0,
      shortlisted: 0,
      interviewsScheduled: 0,
      rejected: 0,
      onHold: 0,
    }
  );
  return (
      <ConsultantLayout>
          <div className='container-fluid mt-3'>
            <div style={{ display: 'flex', alignItems: 'center' }}>
             <Link to="/Employer/ViewBenchSalesReports">
               <i className="fa fa-arrow-left" style={{ color: "#00a7ac", fontSize: 16, marginRight: '10px', marginTop: 8}} aria-hidden="true"></i>
             </Link>
             <h2 style={{ color: "#00a7ac", marginBottom: '0', marginTop: 8 }}>Bench Statistics</h2>
          {/* Date Filter */}
          <OverlayTrigger
            placement="bottom"
            overlay={(props) => (
              <Tooltip id="tooltip" {...props}>
                Select Date Filter
              </Tooltip>
            )}
          >
            <div style={{ marginLeft: "20px", flex: "1" }}>
              <Select
                options={dateFilterOptions}
                placeholder="Select Date Filter"
                value={
                  dateFilterOptions.find(
                    (option) => option.label === filters.SubmittedDate
                  ) || null
                }
                onChange={handleFilterChange}
                className="mt-3"
                styles={{
                  control: (provided) => ({
                    ...provided,
                    height: 50,
                    borderRadius: 10,
                    fontSize: "12px",
                  }),
                  placeholder: (provided) => ({
                    ...provided,
                    textAlign: "left",
                    fontSize: "12px",
                  }),
                  singleValue: (provided) => ({
                    ...provided,
                    textAlign: "left",
                    fontSize: "12px",
                  }),
                }}
              />
            </div>
          </OverlayTrigger>
           </div>                    <hr/>
    <div className="p-4">
   
 
      {data.length === 0 ? (
        <div className="pb-5 text-center">
          <img
            title="No Data"
            className="no-data-img"
            alt="no-data-img"
            src={nodataimg}
            style={{ height: 370 }}
          />
        </div>
      ) : (
        <>
          <table className="table-auto border-collapse border border-gray-400 w-full" style={{fontSize:14}}>
            <thead className="bg-gray-200">
              <tr>
                    <th className="border border-gray-400 px-2 py-1">Name</th>
                    <th className="border border-gray-400 px-2 py-1">Email</th>
                    <th className="border border-gray-400 px-2 py-1">Overall</th>
                    <th className="border border-gray-400 px-2 py-1">New</th>
                    <th className="border border-gray-400 px-2 py-1">
                      Job Submissions
                    </th>
                    <th className="border border-gray-400 px-2 py-1">
                      In-progress
                    </th>
                    {/* <th className="border border-gray-400 px-2 py-1">
                      Offers Released
                    </th> */}
                    <th className="border border-gray-400 px-2 py-1">
                      Interviews Scheduled
                    </th>
                    <th className="border border-gray-400 px-2 py-1">
                      Rejected
                    </th>
                    <th className="border border-gray-400 px-2 py-1">
                      On Hold
                    </th>
                  </tr>
            </thead>
            <tbody>
              {currentData.map((user) => (
                <tr key={user.guid} className="text-center">
                  <td className="border border-gray-400 px-2 py-1">{user.fullName}</td>
                  <td className="border border-gray-400 px-2 py-1">{user.email}</td>
                  <td className="border border-gray-400 px-2 py-1">{user.submittedCount}</td>
                  <td className="border border-gray-400 px-2 py-1">{user.newCount}</td>
                  <td className="border border-gray-400 px-2 py-1">{user.submittedStatusCount}</td>
                  <td className="border border-gray-400 px-2 py-1">{user.inProgressCount}</td>
                   {/* <td className="border border-gray-400 px-2 py-1">{user.submittedCount}</td> */}
                     <td className="border border-gray-400 px-2 py-1">{user.interviewScheduledCount}</td>
                  <td className="border border-gray-400 px-2 py-1">{user.rejectedCount}</td>
                    <td className="border border-gray-400 px-2 py-1">{user.onHoldCount}</td>
                </tr>          
                
              ))}

                 <tr className="bg-gray-100 font-bold text-center">
                    <td className="border border-gray-400 px-2 py-1" colSpan={2}>Totals →</td>
                    <td className="border border-gray-400 px-2 py-1">{totals.overallCount}</td>
                    <td className="border border-gray-400 px-2 py-1">{totals.new}</td>
                    <td className="border border-gray-400 px-2 py-1">{totals.jobSubmission}</td>
                    <td className="border border-gray-400 px-2 py-1">{totals.shortlisted}</td>
                    <td className="border border-gray-400 px-2 py-1">{totals.interviewsScheduled}</td>
                    <td className="border border-gray-400 px-2 py-1">{totals.rejected}</td>
                    <td className="border border-gray-400 px-2 py-1">{totals.onHold}</td>
                  </tr>
            </tbody>
          </table>
 
          {data.length > perPage && (
            <div className="mt-4 flex justify-center">
              <ReactPaginate
                previousLabel={"Prev"}
                nextLabel={"Next"}
                breakLabel={"..."}
                pageCount={pageCount}
                marginPagesDisplayed={2}
                pageRangeDisplayed={5}
                onPageChange={handlePageClick}
                containerClassName={"pagination"}
                activeClassName={"active"}
                disabledClassName={"disable-pagination-button"}
              />
            </div>
          )}
       
        </>
      
      )}
    </div>
    </div>
    </ConsultantLayout>
  );
}
 
 